import { render, staticRenderFns } from "./CareLabelList.vue?vue&type=template&id=5302bb08"
import script from "./CareLabelList.vue?vue&type=script&lang=js"
export * from "./CareLabelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports